import axios from 'axios'

const graphhopperApi = 'https://graphhopper.com/api/1/'

export const graphhopperModes = [
  'foot',
  'hike',
  'bike',
  'car',
  'mtb',
  'racingbike',
  'scooter',
  'truck',
  'small_truck'
]

export const graphhopperSigns = {
  '-7': 'KEEP_LEFT',
  '-3': 'TURN_SHARP_LEFT',
  '-2': 'TURN_LEFT',
  '-1': 'TURN_SLIGHT_LEFT',
  '0': 'CONTINUE_ON_STREET',
  '1': 'TURN_SLIGHT_RIGHT',
  '2': 'TURN_RIGHT',
  '3': 'TURN_SHARP_RIGHT',
  '4': 'FINISH',
  '5': 'REACHED_VIA',
  '6': 'USE_ROUNDABOUT',
  '7': 'KEEP_RIGHT'
}

export const graphhopperIcons = {
  '-8': 'gh-u-turn',
  '-7': 'gh-keep-left',
  '-3': 'gh-turn-sharp-left',
  '-2': 'gh-turn-left',
  '-1': 'gh-turn-slight-left',
  '0': 'gh-continue-on-street',
  '1': 'gh-turn-slight-right',
  '2': 'gh-turn-right',
  '3': 'gh-turn-sharp-right',
  '4': 'gh-finish',
  '5': 'gh-finish',
  '6': 'gh-use-roundabout',
  '7': 'gh-keep-right'
}

export const getRoute = (mode, coordinates, language = 'en') => {
  let url = graphhopperApi + 'route?'
  url += coordinates.map(c => 'point=' + c.join(',')).join('&')
  url += '&vehicle=' + mode
  url += '&locale=' + language
  url += '&points_encoded=false'
  url += '&elevation=true'
  url += '&key=' + process.env.VUE_APP_GRAPHHOPPER
  return axios.get(url)
}

export const getName = (coordinates, language = 'en') => {
  let url = graphhopperApi + 'geocode?reverse=true'
  url += '&limit=1'
  url += '&point=' + coordinates.join(',')
  url += '&locale=' + language
  url += '&key=' + process.env.VUE_APP_GRAPHHOPPER
  return axios.get(url)
}

export const getLocations = (term, limit = 10, language = 'en') => {
  let url = graphhopperApi + 'geocode?q=' + encodeURIComponent(term)
  url += '&limit=' + limit
  url += '&locale=' + language
  url += '&key=' + process.env.VUE_APP_GRAPHHOPPER
  return axios.get(url).then(res => {
    if (res && res.data && res.data.hits) {
      const result = res.data.hits.map(hit => {
        return {
          name: hit.name,
          country: hit.country
        }
      })
      return result
    }
    return null
  })
}
